import { render, staticRenderFns } from "./SurveyRevisionCard.vue?vue&type=template&id=53bd65ac&"
import script from "./SurveyRevisionCard.vue?vue&type=script&lang=js&"
export * from "./SurveyRevisionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports